import { finalize } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { AppStateService } from 'src/app/Services/AppState/app-state.service';
import { NewEnterpriseComponent } from './new-enterprise/new-enterprise.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTableModule } from '@angular/material/table';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { ListPaginatorComponent } from '../list-paginator/list-paginator.component';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-list-enterprise',
  templateUrl: './list-enterprise.component.html',
  styleUrls: ['./list-enterprise.component.scss'],
  standalone: true,
  imports: [
    CommonModule
    , RouterModule
    , MatFormFieldModule
    , MatButtonModule
    , MatInputModule
    , MatTableModule
    , MatMenuModule
    , MatIconModule
    , ListPaginatorComponent
  ]
})
export class ListEnterpriseComponent implements OnInit {
  displayedColumns: string[] = ['nombre', 'menu'];
  searchTerm = '';
  readonly pageSizeOptions = [6, 12, 18];
  constructor(
    public appStateService: AppStateService) { }

  ngOnInit(): void {
    
    this.appStateService.cleanPaginator();
    // Start the global loader after the initial view check has completed.
    queueMicrotask(() => this.onActualizar());
  }

  onActualizar = () => this.appStateService.CompanyServices.GetListEnterpriseManager().subscribe();

  applyFilter(): void {
    this.appStateService.folder.filter = this.searchTerm.trim();
    this.appStateService.folder.page = 1;
    if (this.appStateService.ListPaginator) {
      this.appStateService.ListPaginator.pageIndex = 0;
    }
    this.onActualizar();
  }

  onSearchInput(): void {
    if (!this.searchTerm && this.appStateService.folder.filter) {
      this.applyFilter();
    }
  }
  DeshabilitarEmpresa({company, client}: any) {
    this.appStateService
    .openConfirming({ title: 'Advertencia', subtitle: "¿Desea inhabilitar esta empresa?", type: 'DELETE' })
    .subscribe(res =>{
      if(res?.confirm){
        this.appStateService.loading = true;
        this.appStateService.CompanyServices
        .DeleteCompanyForUser(company, client)
        .pipe(finalize(() => this.appStateService.loading = false))
        .subscribe()
      }
    })
  }

  RemoverEmpresa({expirationDate, companyName}: any) {
    const _companyName = this.appStateService.CompanyName
    const fechaHoy: Date = new Date();
    const fechaRecibida: Date = new Date(expirationDate);
    fechaHoy.setHours(0, 0, 0, 0);
    fechaRecibida.setHours(0, 0, 0, 0);   
    
    if (companyName === _companyName) {
      return true;
    }
    else if (fechaRecibida > fechaHoy) { 
      return true;
    }
    return false;
  }

  AsociarEmpresa() {
    this.appStateService.dialog.open(NewEnterpriseComponent, {
      maxWidth: '95%',
      maxHeight: '95%',
      width: '491px'
    })
  }

  RemoverEmpresaEstilo(expirationDate: string) {
    const fechaHoy: Date = new Date();
    const fechaRecibida: Date = new Date(expirationDate);
    // Verificar si la fecha es válida
    if (isNaN(fechaRecibida.getTime())) {
      console.error("Fecha inválida:", expirationDate);
      return false; // O podrías lanzar un error, dependiendo de tu necesidad
    }    
    // Establecer ambas fechas a la medianoche para una comparación precisa de la fecha
    fechaHoy.setHours(0, 0, 0, 0);
    fechaRecibida.setHours(0, 0, 0, 0);   
    return fechaRecibida < fechaHoy;
  }
  
  

}
